/* game-room-frontend/src/pages/AdminPanel.jsx */
import React, { useCallback, useEffect, useState } from "react";
import UserForm from "../components/admin/UserForm";
import AdminNavbar from "../components/AdminNavbar";

const AdminPanel = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState(null);
  const [newPassword, setNewPassword] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState(null);

  const token = localStorage.getItem("token");

  const fetchUsers = useCallback(async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/users/gerants`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      setUsers(data);
    } catch (err) {
      console.error("Erreur chargement gérants :", err);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  const handleDelete = async (id) => {
    if (!window.confirm("Confirmer la suppression de ce gérant ?")) return;
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/users/${id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      setMessage({ type: "success", text: data.message });
      fetchUsers();
    } catch (err) {
      console.error(err);
      setMessage({ type: "error", text: "Erreur lors de la suppression" });
    }
  };

  const openModal = (user) => {
    setSelectedUser(user);
    setNewPassword("");
    setShowModal(true);
    setMessage(null);
  };

  const handlePasswordUpdate = async () => {
    if (newPassword.length < 6) {
      setMessage({ type: "error", text: "Mot de passe trop court" });
      return;
    }

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/users/${selectedUser._id}/password`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ newPassword }),
      });

      const data = await res.json();

      if (!res.ok) throw new Error(data.message || "Erreur");

      setMessage({ type: "success", text: "Mot de passe mis à jour" });
      setShowModal(false);
      fetchUsers();
    } catch (err) {
      setMessage({ type: "error", text: err.message });
    }
  };

  return (
    <div className="bg-[#0F0F0F] min-h-screen text-white px-4 py-10">
      <AdminNavbar />
      <div className="max-w-5xl mx-auto">
        <h1 className="text-3xl sm:text-4xl font-bold text-center text-blue-400 mb-8">
          👤 Ajouter un gérant
        </h1>

        <UserForm onUserAdded={fetchUsers} />

        <div className="mt-12">
          <h2 className="text-2xl font-semibold text-green-400 mb-4 text-center">
            Liste des gérants
          </h2>

          {message && (
            <p
              className={`text-center mb-4 ${
                message.type === "success" ? "text-green-400" : "text-red-400"
              }`}
            >
              {message.text}
            </p>
          )}

          {loading ? (
            <p className="text-center text-gray-400">Chargement...</p>
          ) : users.length === 0 ? (
            <p className="text-center text-gray-400">Aucun gérant trouvé.</p>
          ) : (
            <div className="overflow-auto rounded-lg shadow">
              <table className="min-w-full text-sm text-left text-white">
                <thead className="bg-[#1a1a1a] text-green-400">
                  <tr>
                    <th className="px-4 py-2">Nom d’utilisateur</th>
                    <th className="px-4 py-2">Rôle</th>
                    <th className="px-4 py-2">Créé le</th>
                    <th className="px-4 py-2 text-right">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {users.map((user, i) => (
                    <tr
                      key={user._id}
                      className={i % 2 === 0 ? "bg-[#121212]" : "bg-[#181818]"}
                    >
                      <td className="px-4 py-2">{user.username}</td>
                      <td className="px-4 py-2 capitalize">{user.role}</td>
                      <td className="px-4 py-2 text-gray-400">
                        {new Date(user.createdAt).toLocaleString("fr-FR")}
                      </td>
                      <td className="px-4 py-2 text-right space-x-2">
                        <button
                          onClick={() => openModal(user)}
                          className="bg-yellow-500 hover:bg-yellow-600 text-black px-3 py-1 rounded text-xs"
                        >
                          ✏️ Modifier
                        </button>
                        <button
                          onClick={() => handleDelete(user._id)}
                          className="bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded text-xs"
                        >
                          🗑️ Supprimer
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {/* Modal mot de passe */}
        {showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
            <div className="bg-[#1c1c1c] rounded-lg p-6 w-[90%] max-w-md">
              <h3 className="text-xl font-bold mb-4 text-center text-blue-400">
                Modifier mot de passe
              </h3>
              <input
                type="password"
                placeholder="Nouveau mot de passe"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="w-full px-4 py-2 rounded bg-[#2C2C2C] text-white mb-4 focus:outline-none"
              />
              <div className="flex justify-end gap-2">
                <button
                  onClick={() => setShowModal(false)}
                  className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700"
                >
                  Annuler
                </button>
                <button
                  onClick={handlePasswordUpdate}
                  className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                >
                  Mettre à jour
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminPanel;

